import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { uiState } from 'react-redux-ui-state';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Typography from '@material-ui/core/Typography';
import Switch from '@material-ui/core/Switch';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';

const propTypes = {
  classes: PropTypes.shape({}).isRequired,
  setUiState: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  checked: PropTypes.bool.isRequired,
  MFAEnabled: PropTypes.bool.isRequired,
  userId: PropTypes.string.isRequired,
  startMFASignupFlow: PropTypes.func.isRequired,
  enrollmentId: PropTypes.string.isRequired,
  removeMFAEnrollment: PropTypes.func.isRequired,
};

export function UnstyledMFACard({
  classes,
  setUiState,
  open,
  MFAEnabled,
  checked,
  userId,
  startMFASignupFlow,
  enrollmentId,
  removeMFAEnrollment,
}) {
  const handleChange = (event) => {
    setUiState({
      checked: !event.target.checked,
      open: true,
    });
  };

  const handleCancel = () => {
    setUiState({
      open: !open,
      checked: !checked,
    });
  };

  const handleConfirm = (callback) => {
    setUiState({ open: !open });
    return callback;
  };

  const confirmButton = (
    <Button
      color="primary"
      className={classes.dialogButton}
      onClick={() =>
        handleConfirm(
          MFAEnabled
            ? removeMFAEnrollment(userId, enrollmentId)
            : startMFASignupFlow(userId, false),
        )
      }
    >
      Confirm
    </Button>
  );
  const switchText = MFAEnabled ? 'enabled' : 'disabled';
  const dialogText = MFAEnabled
    ? 'You are currently enrolled in Multi-factor authentication (MFA). Clicking Confirm will remove MFA from your account.'
    : 'You are currently not enrolled in Multi-factor authentication (MFA). In order to securely enroll you in MFA, you will be logged out of the application and will be guided through the MFA process upon logging back in. Click confirm if you wish to add MFA to your account.';

  return (
    <React.Fragment>
      <Card>
        <CardHeader title="Multi-Factor Authentication" />
        <CardContent className={classes.content}>
          <div className={classes.securityTextContainer}>
            <Typography className={classes.securityText}>
              Add Multi-Factor Authentication To Your Account
            </Typography>
            <Typography className={classes.securitySubtext} variant="body2">
              Help protect your account, even if someone gets ahold of your password. We&apos;ll ask
              for a Passcode provided by an Authentication App of your choice during login.
            </Typography>
          </div>
          <div className={classes.switchContainer}>
            <Switch checked={MFAEnabled} value="MFASwitch" onChange={handleChange} />
            <Typography className={classes[switchText]}>{switchText}</Typography>
          </div>
        </CardContent>
      </Card>
      <Dialog open={open}>
        <DialogContent classes={{ root: classes.dialogText }}>{dialogText}</DialogContent>
        <DialogActions>
          <Button color="secondary" onClick={handleCancel} className={classes.dialogButton}>
            Cancel
          </Button>
          {confirmButton}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

UnstyledMFACard.propTypes = propTypes;

const styles = (theme) => ({
  content: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  securityTextContainer: {
    flexDirection: 'column',
  },
  securityText: {
    fontStyle: 'bold',
    color: theme.customColors.mediumGrey,
  },
  securitySubtext: {
    color: theme.customColors.mediumGrey,
  },
  enabled: {
    textTransform: 'uppercase',
    color: theme.customColors.teal,
    fontSize: '12px',
    fontFamily: '"Roboto Regular", sans-serif',
  },
  disabled: {
    textTransform: 'uppercase',
    color: `${theme.customColors.red} !important`,
    fontSize: '12px',
    fontFamily: '"Roboto Regular", sans-serif',
  },
  dialogText: {
    padding: '8px 16px',
  },
  dialogButton: {
    marginRight: theme.spacing(1),
  },
});

export const uiConfig = {
  name: 'MFACard',
  state: () => ({
    open: false,
    checked: false,
  }),
};

export default uiState(uiConfig)(withStyles(styles)(UnstyledMFACard));
